export default "__VITE_ASSET__BViO8sFP__"